import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from 'react-redux';
import LazyImage from "../../../components/common/LazyImage/LazyImage";
import { ImageUrl } from "../../../utils/constants";
import { MilesIcon, RightArrow, StepsIcon, TimeIcon, /*TopLeaderIcon*/ } from "../../../utils/icons";
import SkeletonLoder from "../../../components/common/skeletonLoder";
import { t } from "i18next";
import { commaSeperator, convertMilesToKm, fetchApi, getInitials } from "../../../utils/methods";
import { LeaderboardContainer, AnswerColumn, LeaderboardHeader, LeaderboardRow, RankColumn, RankText, UserColumn, NewUserName, PaginationCircleNew } from "./styles";
import { BorderBottom, TabBottomLine, TabWrapper } from "../../RecogntionAdmin/styles";
import { GetACMEChallengeCompetitors, GetChallengeCompetitors, /*GetNewGroupChallengeCompetitors,*/ NewGroupChallengeCompetitorsGet } from "../../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import TeamChallengePopup from "./teamChallengePopup";
import { NameInitials } from "../../Manager/styles";
import { IconWrapper } from "../../UserProfile/styles";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom/cjs/react-router-dom";


const ChallengeLeaderBoard = ({ location: { pathname }, /*fetchChallengeCompetitors,*/ challenge,/*fetchTeamChallenge*/brandingColor,companyInfo,role,user }) => {
  const userDetails = useSelector((state) => state.profileData.user);
  const LoggedInUser = userDetails.uid;

  const limit = 50;


  const [pageNo, setPageNo] = useState(1);
  const [loading, setLoading] = useState(false);
  const [challengeCompetitors, setChallengeCompetitors] = useState([]);
  const [competitorsCount, setCompetitorsCount] = useState(0);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [showTeamInfo, setShowTeamInfo] = useState(false);
  const [teamRank, setTeamRank] = useState(null);
  const [activeTab, setActiveTab] = useState('Company');

  // const changeLoading = (bool) => {
  //   setLoading(!bool ? false : true);
  //   // setTotalUsers(10)
  // }

  useEffect(() => {
    const StringArray = pathname.split('/');

    if (challenge.challenge_type === 'new_group' || challenge.is_team_challenge === 1) {
      fetchGroupChallengeCompetitors(StringArray[(StringArray.length - 1)], challenge.event_type, limit, pageNo, false);
    } else {
      fetchChallengeCompetitors(StringArray[(StringArray.length - 1)], challenge.event_type, limit, pageNo, "all", false);

    }

  }, [pageNo]);

  const fetchLeaderboardData = (leaderboardType)=>{
    const StringArray = pathname.split('/');

    if (challenge.challenge_type === 'new_group' || challenge.is_team_challenge === 1) {
      fetchGroupChallengeCompetitors(StringArray[(StringArray.length - 1)], challenge.event_type, limit, pageNo, leaderboardType);
    } else {
      fetchChallengeCompetitors(StringArray[(StringArray.length - 1)], challenge.event_type, limit, pageNo, "all", leaderboardType);

    }

  }


  const setPagination = (activeIndex) => {
    setPageNo(activeIndex);
  };



  const fetchChallengeCompetitors = async (challengeId, challengeType, pageLimit = 25, pageNumber = '1', selectedOption = 'all',leaderboardType=0) => {

    setLoading(true);

    // const isDummy = getState().challenges.isDummyChallenge;
    const isDummy = false;
    const endPoint = isDummy ? GetACMEChallengeCompetitors : GetChallengeCompetitors;
    const isAdminPage = pathname?.includes('company');

    const res = await fetchApi(`${endPoint}/${challengeId}/${challengeType}/${pageNumber}/${pageLimit}/${leaderboardType ? 1 : 0}?response_type=${selectedOption}&company_id=${isAdminPage ? companyInfo?.id :user?.company_id}`, "GET");
    if (res?.data?.message) {
      toast.error(res?.data?.message);
    } else {
      setChallengeCompetitors(res?.data?.response);
      setCompetitorsCount(res?.data?.count)
    }

    setLoading(false);

  }

  const fetchGroupChallengeCompetitors = async (challengeId, challengeType, pageLimit = 25, pageNumber = '1', leaderboardType=0) => {
    setLoading(true);

    const endPoint = NewGroupChallengeCompetitorsGet;

    const payload = {challenge_id:challengeId,event_type:challengeType,page_no:pageNumber,limit:pageLimit,is_global:leaderboardType ? 1 : 0,company_id:role === "ADMIN" ? companyInfo?.id :user?.company_id};

    const res = await fetchApi(`${endPoint}`, "POST",payload);
    if (res?.data?.message) {
      toast.error(res?.data?.message);
    } else {
      setChallengeCompetitors(res?.data?.participants);
      setCompetitorsCount(res?.data?.count)
    }

    setLoading(false);

  }

  const getPaginationCircle = () => {
    let circleButton = [];
    const totalPages = Math.ceil(competitorsCount / limit);
    for (let i = 1; i <= totalPages; i++) {
      circleButton.push(
        <PaginationCircleNew key={i} active={i === pageNo} onClick={() => setPagination(i)}>
          <div className="page-number"><span>Top</span> &nbsp; <span className="page"> {i * limit}</span></div>
          <BorderBottom active={i === pageNo} background={"#F37A65"} />
        </PaginationCircleNew>
      );
    }
    return circleButton;
  };



  const getBackgroundColor = (/*user,*/ index, /*loggedInUserId*/) => {
    if (pageNo === 1) {
      if (index + 1 === 1) return "#DDEEDF";
      if (index + 1 === 2) return "#EBECD5";
      if (index + 1 === 3) return "#FBE8E8";
      return "#F8F8F8";
    } else {
      return "#F8F8F8";
    }
  };

  const getTextColor = (/*user, index, loggedInUserId*/) => {
    window.console.log("hi")
    // return user.uid === loggedInUserId ? "#fff" : "#005c87";
    return "#005c87"
  };

  const DistanceUnit = localStorage.getItem('DISTANCE');

  return (
    <>
      {challenge?.is_global_challenge ? <TabWrapper>
        <TabBottomLine active={activeTab === 'Company'} background={brandingColor} onClick={() =>{fetchLeaderboardData(false);setActiveTab('Company')}}>
          Company
          <BorderBottom active={activeTab === 'Company'} background={brandingColor} />
        </TabBottomLine>
        <TabBottomLine active={activeTab === 'Global'} background={brandingColor} onClick={() =>{fetchLeaderboardData(true);setActiveTab('Global')}}>
          Global
          <BorderBottom active={activeTab === 'Global'} background={brandingColor} />
        </TabBottomLine>
      </TabWrapper>:null}
      <LeaderboardContainer>
        <div className="header">
          <div className="title">
   
            <IconWrapper isColor={challenge.event_type === "Total Steps" ? "#92A4DA" : challenge.event_type === "Total Distance" ? "#DA6C74" : "#B1AA56"}>
              {challenge.event_type === "Total Steps" ? StepsIcon() : challenge.event_type === "Total Distance" ? MilesIcon() : TimeIcon()}
            </IconWrapper>
            <span style={{ marginLeft: "20px" }}>Top Leaders</span>
          </div>
          <div className="leaderboard-update">Leaderboard updates every 1 hour</div>
        </div>
        {Math.ceil(competitorsCount / limit) > 1 && (
          <div className="paginationLeaderboard">
            {getPaginationCircle()}
          </div>
        )}
        <LeaderboardHeader>
          <UserColumn>Users</UserColumn>
          <AnswerColumn>{challenge.event_type === "Total Steps" ? t("Steps Walked") : challenge.event_type === "Total Distance" ? t("Distance Covered") : t("Calories Burned")}</AnswerColumn>
          <RankColumn style={{ width: "auto" }}>Ranks</RankColumn>
          {/* <TimeColumn>Time</TimeColumn> */}
        </LeaderboardHeader>
   
        {loading ? (
          Array.from({ length: 10 }).map((_, index) => (
            <LeaderboardRow key={index} backgroundColor="#f0f0f0" >
              <UserColumn>
                <SkeletonLoder circle width={48} height={48} />
                <NewUserName>
                  <SkeletonLoder width={100} />
                </NewUserName>
              </UserColumn>
              <RankColumn>
                <SkeletonLoder width={50} />
              </RankColumn>
              <AnswerColumn>
                <SkeletonLoder width={70} />
              </AnswerColumn>
              {/* <TimeColumn>
                <SkeletonLoder width={60} />
              </TimeColumn> */}
            </LeaderboardRow>
          ))
   
        ) : (
          challengeCompetitors?.map((user, index) => (
            <LeaderboardRow key={user.uid} backgroundColor={getBackgroundColor(index)} textColor={getTextColor(user, index, LoggedInUser)} style={{ justifyContent: "space-between", width: "auto", cursor: challenge.is_team_challenge && "pointer" }} onClick={() => { if (challenge.is_team_challenge) { setSelectedTeam(user); setShowTeamInfo(true); setTeamRank(index + 1) } }}>
              <UserColumn>
                {(!challenge.is_team_challenge && user?.profile_image !== "profile-Image/default.png") || (challenge.is_team_challenge && user?.logo) ? (<LazyImage
                  style={{ width: "48px", height: "48px", borderRadius: "48px", border: "1px solid #DCDCDC" }}
                  onError={() => window.console.error("Image failed to load")}
                  src={`${ImageUrl}/${challenge.is_team_challenge ? user?.logo : user?.profile_image}`}
                />) : <NameInitials>{getInitials(user?.fullname || user?.name)}</NameInitials>}
   
                <NewUserName style={{ marginLeft: "20px" }}>{challenge.is_team_challenge ? user?.name : user?.fullname}</NewUserName>
                {challenge.is_team_challenge ? <div style={{ marginLeft: "17px" }}>{RightArrow()}</div> : null}
              </UserColumn>
              {challenge.is_team_challenge ? <AnswerColumn style={{ width: "auto" }}>{user?.team_contribution} {challenge.event_type === "Total Steps" ? t("steps") : challenge.event_type === "Total Distance" ? DistanceUnit === "KILOMETER" ? "Km" : t("Miles") : t("Calories")}</AnswerColumn> : <AnswerColumn style={{ width: "auto" }}>{challenge.event_type === "Total Steps" ? commaSeperator(user?.steps) : challenge.event_type === "Total Distance" ? DistanceUnit === "KILOMETER" ? commaSeperator(convertMilesToKm(Math.round(user?.distance) || 0)) : commaSeperator(Math.round(user?.distance) || 0) : commaSeperator(Math.round(user?.calories))} {challenge.event_type === "Total Steps" ? t("steps") : challenge.event_type === "Total Distance" ? DistanceUnit === "KILOMETER" ? "Km" : t("Miles") : t("Calories")}</AnswerColumn>}
   
              <RankColumn style={{ width: "auto" }}>
                {pageNo === 1 ? index + 1 : (limit * (pageNo - 1)) + (index + 1)}
                {/* {index+1} */}
                {/* {index + 1 + (pageNo - 1) * limit}  */}
                <RankText>{index + 1 === 1 ? "st" : index + 1 === 2 ? "nd" : index + 1 === 3 ? "rd" : "th"}</RankText>&nbsp;Rank
              </RankColumn>
   
              {/* <TimeColumn>{formatTime(Math.floor(user.total_time))}</TimeColumn> */}
            </LeaderboardRow>
          ))
        )}
   
        {
          <TeamChallengePopup
            team={selectedTeam}
            showModal={showTeamInfo}
            headerText={selectedTeam.name + " Member"}
            onClose={() => setShowTeamInfo(false)}
            teamRank={teamRank}
            challenge={challenge}
          />
        }
   
      </LeaderboardContainer>
    </>
  );
};

ChallengeLeaderBoard.propTypes = {
  selectedTab: PropTypes.number.isRequired,
  match: PropTypes.object.isRequired,
  challenge: PropTypes.object.isRequired,
  fetchChallengeCompetitors: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  challengeCompetitors: PropTypes.array,
  networkError: PropTypes.string,
  userId: PropTypes.number.isRequired,
  profileImage: PropTypes.string.isRequired,
  fetchTeamChallenge: PropTypes.func.isRequired,
  teamChallenge: PropTypes.array,
  competitorsCount: PropTypes.number,
  t: PropTypes.func,
  challengeAttendees: PropTypes.array,
  brandingColor:PropTypes.string,
  user:PropTypes.object,
  companyInfo:PropTypes.object,
  role:PropTypes.string
};

const mapStateToProps = (state) => ({
  brandingColor:state.wellnessDashboard.brandingColor,
  user: state.profileData.user,
  role: state.auth.role,
})

export default withRouter(connect(mapStateToProps, null)(withTranslation()(ChallengeLeaderBoard)));